<template>
  <div class="blogHeader">
    <div class="blogHeader__title">
      <h1>{{ title }}</h1>
    </div>
    <div class="blogHeader__row">
      <div class="blogHeader__rowCol"></div>
      <div class="blogHeader__rowCol blogHeader__author">
        <div class="blogHeader__authorName" v-if="author">
          {{ author.title }}
        </div>
        <div class="blogHeader__authorDate">{{ formattedDate }}</div>
      </div>
      <div class="blogHeader__rowCol">
        <div class="blogHeader__share">
          <blog-share />
        </div>
      </div>
    </div>
    <div v-if="author" class="blogHeader__image">
      <div class="blogHeader__imageLogo">
        <img :src="$helper.optimizeImageUrl(author.image, 'w_80,h_80,crop')" alt="ofix logo" />
      </div>
      <div class="blogHeader__imageBig">
        <new-image-box
          :alt="title"
          :src="image"
          loading="eager"
          :width="1000"
          :height="700"
          fit
          :image-params="imageParams"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BlogShare from '~/components/Blog/BlogShare';
import NewImageBox from '@/components/NewImageBox';

export default {
  name: 'BlogHeader',
  components: {
    NewImageBox,
    BlogShare,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    author: {
      type: Object,
      default: () => {},
    },
    image: {
      type: String,
      default: '',
    },
    date: {
      type: String,
      default: '',
    },
  },
  computed: {
    formattedDate() {
      const date = this.date.replace(/-/g, '/').replace('T', ' ');
      const isoDate = new Date(date).toISOString();
      return this.$dayjs(isoDate).format('YYYY MMMM DD');
    },
    imageParams() {
      if (this.$device.isMobile) return 'w_400,h_280';
      if (this.$device.isTablet) return 'w_800,h_560';
      return 'w_1000,h_700,crop';
    },
  },
};
</script>

<style lang="scss">
.blogHeader {
  margin-bottom: 6rem;

  @include rwd('tablet') {
    margin-bottom: 4rem;
  }

  &__title {
    max-width: 820px;
    margin: 0 auto 5rem;
    text-align: center;
    font-size: 3.6rem;
    line-height: 4.5rem;
    font-weight: 600;

    @include rwd('small-tablet') {
      margin: 0 4rem;
      font-size: 3rem;
      line-height: 3.8rem;
    }
  }

  &__author {
    text-align: center;
  }

  &__authorName {
    font-size: 1.6rem;
    line-height: 2.4rem;

    a {
      transition: color $tr;

      &:hover {
        color: $cSec;
      }
    }
  }

  &__authorDate {
    font-size: 1.4rem;
    line-height: 2.2rem;
    color: $cAddDark02;
  }

  &__row {
    margin-bottom: 5rem;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  &__rowCol {
    flex: 1;

    @include rwd('tablet') {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }

  &__image {
    position: relative;
  }

  &__imageLogo {
    width: 9.6rem;
    height: 9.6rem;
    position: absolute;
    left: 50%;
    top: 1.5rem;
    z-index: 1;
    background-color: $cWhite;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.1);
    padding: 8px;

    img {
      width: 100%;
      border-radius: 50%;
      transition: opacity $tr;
    }
  }

  &__share {
    display: flex;
    justify-content: flex-end;

    @include rwd('tablet') {
      margin-top: 2rem;
      justify-content: center;
    }
  }
}
</style>
